const popupStack: string[] = [];

export function pushPopup(id: string) {
  if (!popupStack.includes(id)) popupStack.push(id);
}

export function popPopup(id: string) {
  const index = popupStack.lastIndexOf(id);
  if (index >= 0) popupStack.splice(index, 1);
}

export function closeTopPopup() {
  const id = popupStack.pop();
  if (!id) return null;
  document.dispatchEvent(new CustomEvent("desktop:popup-close", { detail: { id } }));
  return id;
}

document.addEventListener("desktop:close-top-popup", () => {
  closeTopPopup();
});
